import type { Stripe } from '@stripe/stripe-js';

type ConfirmStripePaymentParams = {
  stripe: Stripe | null;
  paymentIntentClientSecret: string;
  paymentMethodId: string | null | undefined;
};

export const confirmStripePayment = async ({
  stripe,
  paymentIntentClientSecret,
  paymentMethodId,
}: ConfirmStripePaymentParams): Promise<void> => {
  if (!stripe) {
    throw new Error('Stripe undefined');
  }

  const result = await stripe.confirmCardPayment(paymentIntentClientSecret, {
    payment_method: paymentMethodId ?? undefined,
  });

  if (result.error) {
    // happens if user is in trial
    // if payment confirmation returns payment_intent_unexpected_state
    // check actual payment intent status
    if (result.error.code === 'payment_intent_unexpected_state') {
      const { paymentIntent } = await stripe.retrievePaymentIntent(
        paymentIntentClientSecret
      );

      if (paymentIntent && paymentIntent.status === 'succeeded') {
        // If payment already succeeded (e.g., upgrading from trial)
        // means OK and skipping confirmation
        return;
      }
    }

    // eslint-disable-next-line no-console
    console.error('Error confirming payment: ', result.error);
    throw new Error(result.error.message);
  }

  if (!result.paymentIntent || result.paymentIntent.status !== 'succeeded') {
    throw new Error(
      `Unexpected paymentIntent status: ${result.paymentIntent?.status}`
    );
  }
};
